import { Model, Nullable } from './Model';

export enum FlashcardAnswerEnum {
  REMEMBER = 'REMEMBER',
  REVIEW_AGAIN = 'REVIEW_AGAIN',
}

export default interface FlashcardActivityProgress extends Model {
  flashcardActivity: number;
  answer: Nullable<FlashcardAnswerEnum>;
}
